'use client';

import {
  createContext,
  useContext,
  PropsWithChildren,
  useState,
  Dispatch,
  SetStateAction,
} from 'react';

type TermsOfServiceAcceptanceStatusContext = {
  termsOfServiceAcceptanceStatus: boolean | null;
  setTermsOfServiceAcceptanceStatus?: Dispatch<SetStateAction<boolean | null>>;
} | null;

const TermsOfServiceAcceptanceStatusContext =
  createContext<TermsOfServiceAcceptanceStatusContext>(null);

export function useTermsOfServiceAcceptanceStatus() {
  const termsOfServiceAcceptanceStatus = useContext(
    TermsOfServiceAcceptanceStatusContext,
  );

  if (termsOfServiceAcceptanceStatus === null) {
    throw new Error(
      'useTermsOfServiceAcceptanceStatus has to be used within <TermsOfServiceProvider>',
    );
  }

  return termsOfServiceAcceptanceStatus;
}

interface Props {
  initialTermsOfServiceStatus: boolean | null;
}

export default function TermsOfServiceProvider({
  initialTermsOfServiceStatus,
  children,
}: PropsWithChildren<Props>) {
  const termsOfServiceAcceptanceData = useTermsOfService(
    initialTermsOfServiceStatus,
  );
  return (
    <TermsOfServiceAcceptanceStatusContext.Provider
      value={termsOfServiceAcceptanceData}
    >
      {children}
    </TermsOfServiceAcceptanceStatusContext.Provider>
  );
}

function useTermsOfService(initialValue: boolean | null) {
  const [termsOfServiceAcceptanceStatus, setTermsOfServiceAcceptanceStatus] =
    useState(initialValue);
  return { termsOfServiceAcceptanceStatus, setTermsOfServiceAcceptanceStatus };
}
